import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import React, { useContext, createContext, useState, useRef } from 'react';
import 'prop-types';
import useResize from '../../utils/useResize.js';

var ParentContext = /*#__PURE__*/createContext(null);
var useParentContext = function useParentContext() {
  return useContext(ParentContext);
};

var isWithinWidth = function isWithinWidth(mediaQueryKey, parentElWidth) {
  var hasUpperBound = mediaQueryKey.match(/max-width: (\d*)/);
  var hasLowerBound = mediaQueryKey.match(/min-width: (\d*)/);

  if (hasUpperBound !== null && hasLowerBound !== null) {
    return parentElWidth <= hasUpperBound[1] && parentElWidth >= hasLowerBound[1];
  }

  if (hasUpperBound !== null) {
    return parentElWidth <= hasUpperBound[1];
  }

  if (hasLowerBound !== null) {
    return parentElWidth >= hasLowerBound[1];
  }

  return false;
}; // eslint-disable-next-line max-params


var applyMediaStyle = function applyMediaStyle(parentWidth, styleObj, mediaKey) {
  var styleProp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (parentWidth) {
    if (isWithinWidth(mediaKey, parentWidth.width)) {
      if (styleProp) {
        return styleObj[mediaKey][styleProp];
      }

      return styleObj[mediaKey];
    }

    return {};
  }

  var retObj = {};

  if (styleObj[mediaKey]) {
    retObj[mediaKey] = styleProp ? styleObj[mediaKey][styleProp] : styleObj[mediaKey];
  }

  return retObj;
};
var ParentContextProvider = function ParentContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState({
    width: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  var ref = useRef(null);

  var setParentWidth = function setParentWidth() {
    setDimensions({
      width: ref.current.parentNode.offsetWidth
    });
  };

  useResize(setParentWidth, [ref.current]);
  return /*#__PURE__*/React.createElement(ParentContext.Provider, {
    value: dimensions
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children));
};

export { ParentContext, ParentContextProvider, applyMediaStyle, useParentContext };
